import {
  ICreateLabelPayload,
  IFetchLabelsSuccessResponseBody,
  LabelActionTypes,
  IChangeSelectedLabelsPayload,
  ICreateProjectLabelsPayload,
  IDeleteProjectLabelsPayload,
  IFetchLabelsPayload,
  IRenameLabelPayload,
  IDeleteLabelPayload,
  IDeleteProjectLabelsSuccessPayload,
  ICreateProjectLabelsSuccessPayload,
  IRenameLabelSuccessPayload,
  IDeleteLabelSuccessPayload,
  ICreateLabelSuccessResponseBody,
  ISetLabelSelectionPayload,
} from './types'

export const fetchLabels = (payload: IFetchLabelsPayload) => ({
  type: LabelActionTypes.FETCH_LABELS,
  payload,
})

export const fetchLabelsFailure = () => ({
  type: LabelActionTypes.FETCH_LABELS_FAILURE,
})

export const fetchLabelsSuccess = (payload: IFetchLabelsSuccessResponseBody) => ({
  type: LabelActionTypes.FETCH_LABELS_SUCCESS,
  payload,
})

export const createLabel = (payload: ICreateLabelPayload) => ({
  type: LabelActionTypes.CREATE_LABEL,
  payload,
})

export const createLabelFailure = () => ({
  type: LabelActionTypes.CREATE_LABEL_FAILURE,
})

export const createLabelSuccess = (payload: ICreateLabelSuccessResponseBody) => ({
  type: LabelActionTypes.CREATE_LABEL_SUCCESS,
  payload,
})

export const changeSelectedLabels = (payload: IChangeSelectedLabelsPayload) => ({
  type: LabelActionTypes.CHANGE_SELECTED_LABELS,
  payload,
})

export const setLabelSelection = (payload: ISetLabelSelectionPayload) => ({
  type: LabelActionTypes.SET_LABEL_SELECTION,
  payload,
})

export const deleteProjectLabels = (payload: IDeleteProjectLabelsPayload) => ({
  type: LabelActionTypes.DELETE_PROJECT_LABELS,
  payload,
})

export const deleteProjectLabelsFailure = () => ({
  type: LabelActionTypes.DELETE_PROJECT_LABELS_FAILURE,
})

export const deleteProjectLabelsSuccess = (payload: IDeleteProjectLabelsSuccessPayload) => ({
  type: LabelActionTypes.DELETE_PROJECT_LABELS_SUCCESS,
  payload,
})

export const createProjectLabels = (payload: ICreateProjectLabelsPayload) => ({
  type: LabelActionTypes.CREATE_PROJECT_LABELS,
  payload,
})

export const createProjectLabelsFailure = () => ({
  type: LabelActionTypes.CREATE_PROJECT_LABELS_FAILURE,
})

export const createProjectLabelsSuccess = (payload: ICreateProjectLabelsSuccessPayload) => ({
  type: LabelActionTypes.CREATE_PROJECT_LABELS_SUCCESS,
  payload,
})

export const renameLabel = (payload: IRenameLabelPayload) => ({
  type: LabelActionTypes.RENAME_LABEL,
  payload,
})

export const renameLabelFailure = () => ({
  type: LabelActionTypes.RENAME_LABEL_FAILURE,
})

export const renameLabelSuccess = (payload: IRenameLabelSuccessPayload) => ({
  type: LabelActionTypes.RENAME_LABEL_SUCCESS,
  payload,
})

export const deleteLabel = (payload: IDeleteLabelPayload) => ({
  type: LabelActionTypes.DELETE_LABEL,
  payload,
})

export const deleteLabelFailure = () => ({
  type: LabelActionTypes.DELETE_LABEL_FAILURE,
})

export const deleteLabelSuccess = (payload: IDeleteLabelSuccessPayload) => ({
  type: LabelActionTypes.DELETE_LABEL_SUCCESS,
  payload,
})
